//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import UserList from "@/components/tasks/userList/userList.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AppPermissionsUserGroupView from "./AppPermissionsUserGroupView.vue";

const avatar = require("@/assets/images/user.svg");

export default {
    name: "AppChangeOwner",
    components: {
        UserList,
        AppPermissionsUserGroupView,
        AQModal,
        AQCard
    },
    props: {
        currentOwner: {
            type: Object,
            default: () => {}
        },
        activeModal: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            hasLoadMore: true,
            defaultAvatar: avatar,
            activeOwner: null,
            ownerList: [],
            activeModalvar: false,
            disabledSaveBtn: true
        };
    },
    computed: {
        getCurrentOwner() {
            return `${this.activeOwner.firstName || ""} ${this.activeOwner.lastName || ""}`;
        },
        hasCurrentOwner() {
            return this.activeOwner && (this.activeOwner.firstName || this.activeOwner.firstName || this.activeOwner.email);
        },
        hasSave() {
            return this.activeOwner ? { label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn"), disabled: this.disabledSaveBtn } : null;
        }
    },
    watch: {
        currentOwner: {
            handler(newValue) {
                this.activeOwner = newValue;
            },
            immediate: true
        }
    },
    created() {
        this.actGetUsesListOwners().then(
            data => {
                this.ownerList = data.data;
            }
        );
        this.activeModalvar = this.activeModal;
    },
    methods: {
        ...mapActions("apps", ["actPermissionsChangeOwner", "actGetUsesListOwners"]),
        action(type) {
            if (type === "save") {
                this.actPermissionsChangeOwner(this.activeOwner.id).then(
                    () => {
                        this.$emit("closeActive", this.activeOwner);
                        this.$toast.showNotify({
                            message: this.$t("applicationChangeOwner.ownerChanged"),
                            type: "positive"
                        });
                    }
                );
            } else {
                this.$emit("closeActive");
            }
        },
        setNewOwner(newOwner) {
            if (newOwner) {
                this.activeOwner = this.ownerList.find(element => element.id === newOwner);
                this.disabledSaveBtn = false;
            } else {
                this.activeOwner = null;
            }
        }
    }
};
